/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ContributedDays model module.
 * @module model/ContributedDays
 * @version 1.0.0
 */
class ContributedDays {
    /**
     * Constructs a new <code>ContributedDays</code>.
     * @alias module:model/ContributedDays
     */
    constructor() { 
        
        ContributedDays.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ContributedDays</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ContributedDays} obj Optional instance to populate.
     * @return {module:model/ContributedDays} The populated <code>ContributedDays</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ContributedDays();

            if (data.hasOwnProperty('percent_25')) {
                obj['percent_25'] = ApiClient.convertToType(data['percent_25'], 'Number');
            }
            if (data.hasOwnProperty('percent_50')) {
                obj['percent_50'] = ApiClient.convertToType(data['percent_50'], 'Number');
            }
            if (data.hasOwnProperty('percent_100')) {
                obj['percent_100'] = ApiClient.convertToType(data['percent_100'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} percent_25
 */
ContributedDays.prototype['percent_25'] = undefined;

/**
 * @member {Number} percent_50
 */
ContributedDays.prototype['percent_50'] = undefined;

/**
 * @member {Number} percent_100
 */
ContributedDays.prototype['percent_100'] = undefined;






export default ContributedDays;

